import { useEffect, useRef } from "react";
import { useRosterState } from "amazon-chime-sdk-component-library-react";
import toast from "react-hot-toast";
import { MeetingJoinType } from "../types";
import { getMeetingStatusFromExternalId } from "../services/chime-service";

/**
 * Watches the meeting roster for headset connections.
 * Shows a toast on first connection and calls the optional onHeadsetConnected callback.
 */
export const useHeadsetConnected = (onHeadsetConnected?: () => void) => {
  const { roster } = useRosterState();
  const headsetConnectedRef = useRef(false);

  useEffect(() => {
    const hasHeadset = Object.values(roster).some((attendee: any) => {
      if (!attendee?.externalUserId) return false;
      const { userType } = getMeetingStatusFromExternalId(attendee.externalUserId);
      return userType === MeetingJoinType.Headset;
    });

    if (hasHeadset && !headsetConnectedRef.current) {
      headsetConnectedRef.current = true;
      toast.success("Headset Connected", { duration: 3000 });
      onHeadsetConnected?.();
    }

    if (!hasHeadset && headsetConnectedRef.current) {
      headsetConnectedRef.current = false;
      toast.error("Headset Disconnected", { duration: 3000 });
    }
  }, [roster]);
};
